import styles from "../css/SetupTable.module.css";

export default function SetupTable({ items }) {
  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.description}>Description</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody>
        {items.map((item, index) => (
          <tr key={item.description}>
            <td>{item.description}</td>
            <td>
              <button className={styles.actionButton} onClick={item.action}>
                Edit
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
